import { render, staticRenderFns } from "./CreateLogoCustomer.vue?vue&type=template&id=64fa3fd4&scoped=true"
import script from "./CreateLogoCustomer.vue?vue&type=script&lang=js"
export * from "./CreateLogoCustomer.vue?vue&type=script&lang=js"
import style0 from "./CreateLogoCustomer.vue?vue&type=style&index=0&id=64fa3fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa3fd4",
  null
  
)

export default component.exports